import React from 'react';
import { UserManagement } from '../components/admin/UserManagement';

export const AdminPage: React.FC = () => {
  return <UserManagement />;
};
